module.exports = __webpack_public_path__ + "static/media/kroggamlakirurgen.8ce68c08.png";